import React from "react";
import AddObserveInformReport from "./AddObserveInformReport";
import CompanyLogo from "../../../../assets/images/Sidebar/logo/amelio-logo.png";

/**
 * PublicObserveInformReport - A publicly accessible page for submitting observe inform reports.
 * This component wraps the AddObserveInformReport form with public-specific styling and branding.
 * Users accessing this page via QR code do not need to be logged in.
 */
const PublicObserveInformReport: React.FC = () => {
  return (
    <div className="tw-min-h-screen tw-bg-gray-100">
      {/* Header */}
      <header className="tw-bg-[#152846] tw-py-4 tw-px-6 tw-shadow-md">
        <div className="tw-max-w-4xl tw-mx-auto tw-flex tw-items-center tw-justify-center tw-space-x-4">
          <img src={CompanyLogo} alt="Amelio Logo" className="tw-h-10" />
          {/* <span className="tw-text-white tw-text-lg tw-font-medium">
            Observe. Inform. Report.
          </span> */}
        </div>
      </header>

      {/* Main Content */}
      <main className="tw-py-4">
        <AddObserveInformReport isPublic={true} />
      </main>

      {/* Footer */}
      <footer className="tw-bg-gray-200 tw-py-4 tw-text-center">
        <p className="tw-text-gray-600 tw-text-sm">
          © {new Date().getFullYear()} Amelio Group. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default PublicObserveInformReport;
